/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */

import React from 'react';
import { View, StyleSheet, Dimensions, TouchableOpacity } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import ItemDetail from '@components/global/ItemDetail';
import Colors from '@global/colors';
import { isWeb, isNative } from '@global/screens';
import Image from '@components/global/Image';
import { parseDate, currency, downloadFile } from '@global/helpers';

const dimension = Dimensions.get('window');

const OrderHeader = (props) => {
  const detailData = props.detailData ? props.detailData : {};
  const isConfirm = detailData.status == 'need_approval';

  const detailLeft = [
    {
      name: 'Created by',
      value:
        detailData.created_by && detailData.created_by.name
          ? detailData.created_by.name
          : '-',
    },
    {
      name: 'Source Doc',
      value:
        detailData.source_order && detailData.source_order.reference_code
          ? detailData.source_order.reference_code
          : '-',
    },
    {
      name: 'Sales Team',
      value: detailData.sales_team ? detailData.sales_team.name : '-',
    },
    // {
    //   name: 'Special Expired Period',
    //   value: detailData.customer
    //     ? detailData.customer.special_expired_period
    //     : '-',
    // },
    {
      name: 'Scheduled Date',
      value:
        detailData.scheduled_date + ' ' + detailData.scheduled_time
          ? parseDate(detailData.scheduled_date) +
            ' ' +
            detailData.scheduled_time
          : '-',
    },
    {
      name: 'Total Value',
      value: detailData.total_amount
        ? currency(detailData.total_amount, true)
        : '-',
    },
    {
      name: 'Delivery Order Number',
      value: detailData.delivery_order_number
        ? detailData.delivery_order_number
        : '-',
    },
    {
      name: 'Upload PDF/Photo',
    },
  ];

  if (detailData?.status == 'approved' && detailData.state_histories?.length) {
    const lastState =
      detailData.state_histories[detailData.state_histories.length - 1];
    const isApprovedByExist =
      lastState?.to_status.includes('approved') &&
      lastState?.status_changed_by?.name;

    if (isApprovedByExist) {
      const spliceData = {
        name: 'Approved By',
        value: lastState.status_changed_by.name,
      };

      detailLeft.splice(1, 0, spliceData);
    }
  }

  const onDownloadAttachment = (url) => {
    if (url) {
      downloadFile(url, 'return-order-document', '', true);
    }
  };

  const renderListField = () => (
    <React.Fragment>
      {detailLeft.map((item, idx) => (
        <ItemDetail
          name={item.name}
          value={item.value}
          key={idx}
          withoutBorder={isWeb ? idx == detailLeft.length - 1 : false}
        />
      ))}
    </React.Fragment>
  );

  const DocumentPlaceholder = () => (
    <SociollaText>No document attached.</SociollaText>
  );

  const DocumentAttachment = ({ url, name, onDownloadAttachment }) => (
    <TouchableOpacity
      activeOpacity={0.8}
      style={styles.attachmentItem}
      onPress={() => onDownloadAttachment(url)}>
      <Image
        style={[styles.attachmentIcon, { width: 50, height: 50 }]}
        width={40}
        height={40}
        isResolveAsset
        source={{ uri: url }}
      />
      <SociollaText style={styles.attachmentText}>{name}</SociollaText>
    </TouchableOpacity>
  );

  const DocumentAttachmentList = ({ attachments, onDownloadAttachment }) => (
    <View
      style={[
        styles.attachment,
        attachments.length < 3 ? { justifyContent: 'flex-start' } : {},
      ]}>
      {attachments.map((attachment, index) => (
        <DocumentAttachment
          key={index}
          url={attachment.url}
          name={attachment.name}
          onDownloadAttachment={onDownloadAttachment}
        />
      ))}
    </View>
  );

  const renderDocumentSection = () => (
    <View style={styles.documentWrapper}>
      {!detailData?.upload_return_form ? (
        <DocumentPlaceholder />
      ) : (
        <DocumentAttachmentList
          attachments={[detailData.upload_return_form]}
          onDownloadAttachment={onDownloadAttachment}
        />
      )}
    </View>
  );

  return (
    <View
      style={[
        styles.wrapper,
        isConfirm ? { paddingBottom: !isNative ? 15 : 70 } : {},
      ]}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: isWeb ? 'flex-start' : 'space-between',
          ...(!isWeb ? { flexWrap: 'wrap' } : {}),
        }}></View>
      <View style={styles.mainContainer}>
        <View style={styles.contentHeaderContainer}>
          {renderListField()}
          {renderDocumentSection()}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    padding: 15,
  },
  documentWrapper: {
    width: '100%',
    padding: 15,
    ...(!isWeb
      ? { borderBottomWidth: 1, borderBottomColor: Colors.grey0 }
      : {}),
  },
  attachment: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    ...(!isWeb ? { justifyContent: 'space-between' } : {}),
  },
  attachmentItem: {
    width: isWeb ? 100 : '30%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    borderRadius: 4,
    marginRight: 10,
    marginBottom: 10,
  },
  attachmentIcon: {
    marginBottom: 10,
  },
  attachmentText: {
    fontSize: 13,
  },
  contentHeaderContainer: {
    width: isWeb ? '50%' : '100%',
    paddingRight: isWeb ? 15 : 0,
  },
  mainContainer: {
    width: !isNative ? '100%' : dimension.width,
    marginTop: 15,
    flexDirection: isWeb ? 'row' : 'column',
  },
});

export default OrderHeader;
